import React, { forwardRef } from 'react';

import IconClose from '$partials/icons/icon-close.jsx';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

const TagCheckbox = forwardRef((
    /** @type {import('$types/components/partials/fields.ts').TagCheckboxProps} */
    {
        checked,
        className = '',
        disabled = false,
        errors,
        id: idProp,
        label,
        labelClassName,
        name,
        onChange,
        value,
        ...remainingProps
    },
    /** @type {React.ForwardedRef<(HTMLInputElement)>} */
    ref
) => {
    const id = idProp ?? `frm-${name}-${value}`;

    return (
        <div
            className={'' + (className ? ` ${className}` : '')}>
            <div className='relative'>
                <label
                    className='cursor-pointer select-none inline-flex items-center px-16 h-[44px] rounded-[4px] bg-input-background has-[:checked]:bg-tag-main-background-selected-brand has-[:checked]:text-tag-main-text-selected has-[:disabled]:opacity-50 type-style-eyebrow'
                    htmlFor={id}>
                    <input
                        aria-invalid={errors}
                        aria-labelledby={id}
                        checked={checked}
                        className='appearance-none absolute peer w-full h-full left-0 top-0 rounded-[4px]'
                        disabled={disabled}
                        id={id}
                        name={name}
                        onChange={onChange}
                        ref={ref}
                        type='checkbox'
                        value={value}
                        {...remainingProps} />

                    <span
                        className={'' + (labelClassName ? ` ${labelClassName}` : '')}
                        dangerouslySetInnerHTML={{ __html: label }} />

                    <span
                        aria-hidden='true'
                        className='ml-5 peer-[:checked]:block hidden'>
                        <IconClose />
                    </span>
                </label>
            </div>
        </div>
    );
});

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

TagCheckbox.displayName = 'TagCheckbox';

export default TagCheckbox;
